import harvardUniversityLogo1Png from '@listening/assets/astro/images/Harvard_University_logo-1.png';
import mitSvg from '@listening/assets/astro/images/mit.svg';
import rectangle458Svg from '@listening/assets/astro/images/Rectangle-458.svg';
import yaleSvg from '@listening/assets/astro/images/yale.svg';

export function EduBannerSection() {
  return (
    <section
      className='flex w-full flex-col items-start gap-8 overflow-hidden py-8 sm:pt-30 sm:pb-14 lg:pt-26 lg:pb-18'
      id='edu'
    >
      <h3 className='max-w-[350px] self-center text-center text-[18px] leading-[24px] font-[500] text-neutral-525 sm:text-[24px] sm:leading-[32px] lg:max-w-[auto]'>
        Trusted by 50,000+ students & researchers at ...
      </h3>
      <div className='relative h-[88px] w-full overflow-hidden sm:size-auto'>
        <div className='infinite-scroll-wrapper absolute flex gap-8 overflow-hidden sm:relative sm:overflow-visible'>
          <EduBannerItemGroup />
          <EduBannerItemGroup />
          <EduBannerItemGroup />
          <EduBannerItemGroup />
          <EduBannerItemGroup />
          <EduBannerItemGroup />
          <EduBannerItemGroup />
          <EduBannerItemGroup />
        </div>
      </div>
      <div />
    </section>
  );
}

function EduBannerItem({
  src,
  alt,
  height,
}: {
  src: string;
  alt: string;
  height?: number;
}) {
  return (
    <div className='flex h-[88px] max-w-[275px] flex-none items-center justify-center rounded-full bg-mist-825/50 px-8'>
      <img alt={alt} height={height} loading='lazy' src={src} />
    </div>
  );
}

function EduBannerItemGroup() {
  return (
    <div className='flex flex-none gap-8'>
      <EduBannerItem alt='Yale University' src={yaleSvg} />
      <EduBannerItem alt='MIT' src={mitSvg} />
      <EduBannerItem
        alt='Columbia University'
        height={100}
        src={rectangle458Svg}
      />
      <EduBannerItem alt='Harvard University' src={harvardUniversityLogo1Png} />
    </div>
  );
}
